<template lang="pug">
  v-container
    v-card
      v-card-title
        v-btn(color="primary" @click="newCompany()") {{ $t('words.new') }}
      v-data-table.elevation-1( 
          :items="companies" 
          :headers="headers"
        )
        template( v-slot:items="props" )
          td {{ props.item.name }}
          td {{ props.item.email }}
          td {{ props.item.identity || props.item.cnpj }}
          td.text-xs-center
            v-menu(offset-y, left)
              template(v-slot:activator="{ on }")
                v-btn.mx-0(v-on="on", @click.stop="" icon='')
                  v-icon(small='')
                    | more_vert
              v-list
                v-list-tile(@click="editCompany(props.item)")
                  v-list-tile-title {{ $t('words.edit') | capitalize }}
    CompanyDialog(v-model="dialog", :company="dialogCompany")
</template>

<script>
import { mapState, mapActions } from 'vuex'
import CompanyDialog from './Company'

export default {
  name: 'companies',

  components: {
    CompanyDialog
  },

  data () {
    return {
      dialog: false,
      dialogCompany: null,
      headers: [
        {text: 'Nome', value: 'name'},
        {text: 'Email', value: 'email'},
        {text: 'CNPJ', value: 'cnpj'},
        {text: 'Ações', value: 'actions', sortable: false, align: 'center'}
      ]
    }
  },

  computed: {
    ...mapState({
      companies: (state) => state.adminCompanies
    })
  },

  mounted () {
    this.loadAdminCompanies()
  },

  methods: {
    ...mapActions(['loadAdminCompanies']),
    editCompany (company) {
      this.dialogCompany = company
      this.dialog = true
    },
    newCompany () {
      this.dialogCompany = {}
      this.dialog = true
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/pages/Companies.vue